import PropTypes from "prop-types"
import React, { useMemo } from "react"
import { Box, Typography } from "@material-ui/core/index"

const WaitingForPayment = ({ paymentType }) => {
  const waitingText = useMemo(
    () => {
      if (paymentType === "check") {
        return "Check payment method selected. Waiting to mark as paid."
      } else if (paymentType === "ach") {
        return "ACH payment method selected. Waiting to receive it."
      } else {
        return ""
      }
    },
    [paymentType]
  )
  return (
    <Box>
      <Typography variant="h4" color="primary" style={{ marginBottom: "20px" }}>
        {waitingText}
      </Typography>
    </Box>
  )
}

WaitingForPayment.propTypes = {
  paymentType: PropTypes.string,
}

export default WaitingForPayment
